import React, {useEffect} from 'react';
import {Helmet} from "react-helmet";
import styles from './ShowTheWay.module.scss';

interface IShowTheWayProps {
  latitude: number;
  longitude: number;
  className?: string;
}

const ShowTheWay = ({className, latitude, longitude}: IShowTheWayProps) => {
  useEffect(() => {
    if ((window as any).showtheway) {
      (window as any).showtheway.autoInit();
    }
  }, []);
  return (
    <>
      <Helmet>
        <script src="https://dealandgo.co.il/showtheway.js" defer type="text/javascript"></script>
      </Helmet>
      <div className={`showtheway ${styles.showTheWay} ${className}`}>
        <a href={`https://showtheway.io/to/${latitude},${longitude}`}
           target="_blank"
           rel="noopener noreferrer nofollow"
           title={`הראה את הדרך אל ${latitude},${longitude} עם אפליקציית הניווט המועדפת עליך`}>ניווט</a>
      </div>
    </>
  )
};
ShowTheWay.defaultProps = {
  className: '',
};
export default React.memo(ShowTheWay);
